import { useContext, useEffect } from "react";
import TitleContext from "../context/TitleContext";
import ViewSmsBotRecentActivity from "../components/smsBotProbes/ViewSmsBotRecentActivity";

const SMSBotRecentActivityPage = () => {
  const { setTitle } = useContext(TitleContext);

  useEffect(() => {
    setTitle("SMS Bot Recent Activity");
  }, [setTitle]);
  return (
    <>
      <ViewSmsBotRecentActivity />
    </>
  );
};
export default SMSBotRecentActivityPage;
